import React from "react";
import { Box, Typography } from "@mui/material";
import { useAppDispatch } from "src/hooks/redux";
import { logoutSuccess } from "src/store/reducers/authSlice";
import { closeModal } from "src/store/reducers/modalSlice";

import { CrossCircleFilledIcon } from "../../Icons";
import { SubmitButton } from "../Button/SubmitButton";

export const LogOutModal = () => {
  const dispatch = useAppDispatch()
  const onButtonClick = () => {
    dispatch(logoutSuccess())
    dispatch(closeModal())
  }

  return (
    <Box
      sx={{
        padding: "33px",
        borderRadius: "16px",
        width: "496px",
      }}
    >
      <Box
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          textAlign: "center",
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            borderRadius: "50%",
            width: "80px",
            height: "80px",
            backgroundColor: "rgba(213, 31, 41, 0.1)",
            marginBottom: "24px",
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              borderRadius: "50%",
              width: "40px",
              height: "40px",
              backgroundColor: "#D62F39",
              color: "white",
            }}
          >
            <CrossCircleFilledIcon />
          </Box>
        </Box>
        <Typography
          sx={{
            fontSize: "16px",
            fontWeight: "400",
            color: "#363636",
            marginBottom: "16px",
          }}
        >
          You have logged out
        </Typography>
      </Box>
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
        }}
      >
        <SubmitButton
          title='Log out'
          onClick={onButtonClick}
          sx={{
            flex: 0.7,
            maxWidth: "208px",
          }}
        />
      </Box>
    </Box>
  );
};
